import { isEmpty } from "lodash";
import { LOCAL_STORAGE_KEYS, PORTAL_NAME_CHANGE_FROM } from "../constants/Constants";
import { LOCALISE_LANGUAGES } from "../constants/LanguageConstants";
import { LANGUAGE_EVENTS, GET_LANGUAGE, CHANGE_PORTAL_NAME } from "../reducers/language-reducer";
import storage from "../services/storage";
import reduxStore from "../configureEnvStore";
import { PublicVariables } from "../constants/PublicVariables";
import { setLanguageObject } from "../shared/function";

//#region -- get language
const getLanguageStart = () => {
    return {
        event: LANGUAGE_EVENTS.GET_LANGUAGE,
        type: GET_LANGUAGE.START,
    };
};

const getLanguageSuccess = (data) => {
    return {
        event: LANGUAGE_EVENTS.GET_LANGUAGE,
        type: GET_LANGUAGE.SUCCESS,
        payload: data,
    };
};

/* This function retrieves data from the 'get language' API and filters it based on active language, handling country language class, and name */
const filterCountryLanguageList = (result, dispatch, isForPrivacyPolicy = false) => {
    let updatedCountryLanguageList = {
        defaultLanguage: result?.defaultLanguage,
        languages: result?.languages,
        activeLanguageList: [],
    };

    /* Here, a country flag class key has been added. This feature is specifically implemented for active company entities */
    let activeLanguages = [];

    if (isForPrivacyPolicy) {
        updatedCountryLanguageList.defaultLanguage = result?.sessionConfigurations?.LANGUAGE ?? PublicVariables.defaultLanguage;
        updatedCountryLanguageList.languages = result?.privacyPolicies;
        activeLanguages = result?.privacyPolicies?.filter((lang) => lang.isActive);
    } else {
        activeLanguages = result?.languages?.filter((lang) => lang.isActive);
    }
    updatedCountryLanguageList.activeLanguageList = activeLanguages?.map((language) => ({
        ...language,
        class: LOCALISE_LANGUAGES?.find((lang) => lang.languageCode === language.languageCode)?.class,
    }));

    const defaultCountryLanguageObj = updatedCountryLanguageList.activeLanguageList?.find(
        (obj) => obj.languageCode === updatedCountryLanguageList.defaultLanguage
    );
    /* - We first check the local storage to determine if a language has already been set. 
       - If not found, we then proceed to check the default language of the window. 
       - If neither is available, we select our predefined default language 
    */
    const languageInStorage = storage.get(LOCAL_STORAGE_KEYS.USER_LANGUAGE);
    const selectedCountryLanguageObj = updatedCountryLanguageList.activeLanguageList?.find((lang) => lang.languageCode === languageInStorage);
    let finalSelectedLanguage = {};

    if (languageInStorage && selectedCountryLanguageObj) {
        finalSelectedLanguage = selectedCountryLanguageObj;
    } else if (window?.navigator?.language) {
        const browserLang = window.navigator.language?.replace("-", "_");
        const index = updatedCountryLanguageList.activeLanguageList?.findIndex((lang) => lang.languageCode === browserLang);
        if (index >= 0) {
            finalSelectedLanguage = updatedCountryLanguageList.activeLanguageList[index];
        } else {
            finalSelectedLanguage = defaultCountryLanguageObj;
        }
    } else {
        finalSelectedLanguage = defaultCountryLanguageObj;
    }

    console.log("New language: ", finalSelectedLanguage);
    setLanguageObject(finalSelectedLanguage);

    // Change Portal Name
    if (!isEmpty(result?.languages)) dispatch(setPortalNames(PORTAL_NAME_CHANGE_FROM.ISCOMPANY_AVAILABLE, result));

    /* The API data is dispatched, and simultaneously, the filtered data is appended below our API data result. */
    dispatch(getLanguageSuccess(updatedCountryLanguageList));
};

/* This function is a dispatch function that handles the data from the 'get language' API and filters it accordingly */
export const setLanguagesInDataReducer = (data, isForPrivacyPolicy) => async (dispatch) => {
    dispatch(getLanguageStart());
    filterCountryLanguageList(data, dispatch, isForPrivacyPolicy); // Filtered our API data
};

//#endregion

//#region -- change language

/* This function dispatch change selected country language data */
export const changeLanguage = (language) => async (dispatch) => {
    setLanguageObject(language);
    if (language) {
        console.log("New language: ", language);
        /* Set the country code in local storage so that when we reload the page, we can retrieve the previously selected country language */
        storage.set(LOCAL_STORAGE_KEYS.USER_LANGUAGE, language.languageCode);

        const allStoreData = reduxStore.getState();
        if (!isEmpty(allStoreData.onLoadData.privacyPolicyData)) {
            dispatch(setPortalNames(PORTAL_NAME_CHANGE_FROM.PRIVACY_POLICY, allStoreData.onLoadData.privacyPolicyData));
        } else {
            dispatch(setPortalNames(PORTAL_NAME_CHANGE_FROM.ISCOMPANY_AVAILABLE, allStoreData.onLoadData.isCompanyAvailableData));
        }
    }
};
//#endregion

//#region -- change Portal name
const changePortalNameSuccess = (data) => {
    return {
        event: LANGUAGE_EVENTS.CHANGE_PORTAL_NAME,
        type: CHANGE_PORTAL_NAME.SUCCESS,
        payload: data,
    };
};

export const setPortalNames = (from, data) => (dispatch) => {
    const currentLanguageObj = PublicVariables.currentLanguageObj;
    let selectedLanguage = false;

    if (from === PORTAL_NAME_CHANGE_FROM.ISCOMPANY_AVAILABLE && data.branding) {
        selectedLanguage = data.languages.find((lang) => lang.languageCode == currentLanguageObj.languageCode);
    } else if (from === PORTAL_NAME_CHANGE_FROM.PRIVACY_POLICY && data.sessionConfigurations?.BRANDING === "1") {
        selectedLanguage = data.privacyPolicies.find((lang) => lang.languageCode == currentLanguageObj.languageCode);
    }

    if (selectedLanguage) {
        const { agentPortalName, guestPortalName } = selectedLanguage;
        dispatch(changePortalNameSuccess({ agentPortalName, guestPortalName }));
    }
};
//#endregion
